import { createBuilderModule } from '../../../register-builder/builder-module';
import { blockElement } from '../../../register-builder/element-factories';
import { TabsSection } from './TabsSection';

export default createBuilderModule(TabsSection, {
  name: 'TabsSection',
  image: 'https://cdn.zappy.app/4f358d25a3f6a8c4560b262b80b3dd63.png',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Section Heading',
    },
    {
      name: 'subheading',
      type: 'string',
      defaultValue: 'Section Subheading',
    },
    /**
     * Related forum thread implementing Tabs https://forum.builder.io/t/react-custom-component-containing-editable-subcomponents/25
     */
    {
      name: 'tabs',
      /**
       * @see Input.broadcast
       * Without / With: https://cdn.zappy.app/4f79ffebd8463d62e5aa82152fd5c8b5.png
       */
      broadcast: true,
      type: 'list',
      subFields: [
        {
          name: 'heading',
          type: 'string',
          defaultValue: 'Tab Heading',
        },
        {
          name: 'id',
          type: 'string',
        },
        {
          name: 'content',
          type: 'uiBlocks',
          hideFromUI: true,
          defaultValue: [
            blockElement({
              heading: 'Default New Tab',
              mediaSrc:
                'https://cdn.zappy.app/6db2607df31caecba4c910998dba31af.png',
            }),
          ],
        },
      ],
      defaultValue: [
        {
          heading: 'Tab Heading 01',
          content: [
            blockElement({
              heading: 'Tab 01',
              mediaSrc:
                'https://cdn.zappy.app/3ca6571fdb1b5e19796bc8adbb55246d.png',
            }),
          ],
        },
        {
          heading: 'Tab Heading 02',
          content: [
            blockElement({
              heading: 'Tab 02',
              mediaSrc:
                'https://cdn.zappy.app/6db2607df31caecba4c910998dba31af.png',
            }),
          ],
        },
      ],
    },
    {
      name: 'changeUrlOnTabChange',
      type: 'boolean',
    },
  ],
});
